import Vue from 'vue';

let handleOutsideClick: (e: Event) => void;

Vue.directive('outside-click', {
    bind(el, binding, vnode) {
        handleOutsideClick = (e: Event) => {
            e.stopPropagation();
            const target = e.target as EventTarget;
            const context = vnode.context as any;

            const { handler, excludeSelectors } = binding.value;
            let clickedOnExcludedElement = false;

            excludeSelectors.forEach((refName: any) => {
                if (!clickedOnExcludedElement) {
                    const excludedElements = document.querySelectorAll(refName) as NodeList;

                    excludedElements.forEach((excludedElement: Node) => {
                        if (excludedElement !== undefined) {
                            clickedOnExcludedElement =
                                clickedOnExcludedElement ||
                                excludedElement === target || excludedElement.contains(target as Element);
                        }
                    });
                }
            });

            if (!el.contains(target as Element) && !clickedOnExcludedElement) {
                context[handler]();
            }
        };

        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);
    },
    unbind() {
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('touchstart', handleOutsideClick);
    }
});
